import React, { Component } from 'react';
import { Growl } from 'primereact/growl';
import {FileUpload} from 'primereact/fileupload';
import { Button } from 'primereact/button';

import servicioArchivo from '../servicios/ServicioArchivos';
import servicioCargaXml from '../servicios/ServicioCargaxml';

export default class Cargaxmltimbradoporfuera extends Component {
  constructor() {
    super();
    this.state = {
      cargaxml: {}
    }
  }

  leerXml = (event) => {
    let { cargaxml } = this.state;
    var archivoxml = event.files[0];
    console.log(archivoxml);
    servicioArchivo.obtenerBytesBase64StringArchivo(archivoxml, cargaxml, 'xml');
    this.setState(cargaxml);
  }

  guardar=()=>{
    const {cargaxml}=this.state;
    console.log(cargaxml.xml);
    servicioCargaXml.cargaxml([cargaxml.xml]).then(response=>{
      if (response.data.includes("xito")) 
          this.growl.show({ severity: 'success', summary: 'Exito', detail: response.data });
      else
      this.growl.show({ severity: 'error', summary: 'Error Message', detail: response.data });
    }).catch(error=>{
        this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'Existe un error con la conexion al servidor' });
    });
  }

  render() {
    return (<div className="card card-w-title">
      <Growl ref={(el) => this.growl = el} />
      <h1>Cargar Xml timbrados por fuera</h1>
      <h4>Los campos con (*) son obligatorios</h4>
      <div className="p-grid p-fluid">
        <div className="p-col-12 p-md-4">
          <h4>*Archivo xml:</h4>
          <FileUpload id="fileXml" mode="basic" name="fileXml" chooseLabel="archivo .xml" auto={true} onSelect={this.leerXml}  accept=".xml" />
        </div>
        <div className="p-col-12 p-md-4">
          <br/><br/><br/>
          <Button label="Carga xml" className="p-button-rounded p-button-warning" onClick={this.guardar} />         
        </div>
      </div>
    </div>);
  }

}